module.exports = __webpack_public_path__ + "static/media/telegram-logo.fd84719d.svg";